/*[03/28/22,PC_DF_11,WW-371], Priyanka D */
import React from 'react';
import {
    Document,
    Page,
    Text,
    Image,
    View,
    Font,
    StyleSheet,
} from '@react-pdf/renderer';
import Select from 'react-select';

const EnersysPDFComponent = props => {
    const { doortype, DoorSwingType, WillYouNeedArray, SwingRefdata, item, ItemID, qty } = props;

    const IdsArray = [];
    let count = 0;

    const styles = StyleSheet.create({

        page: {
            backgroundColor: 'white',
            marginTop: '1.27cm',
            marginBottom: '1.09cm',
            marginLeft: "0.69cm",


        },
        body: {
            width: "8.5 in",
            margin: "0 in .1875 in",
            backgroundColor: 'white',
            display: 'block',

        },
        view: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            width: '50%',

        },
        div: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-evenly',
            width: '50%',
        }, text: {
            color: '#0081C6',
            size: '0.5rem',
            margin: "auto"
        },
        section: {
            margin: 10,
            padding: 10,
            flexGrow: 1
        },

    });

    //const resultArray = PDFImageIds.map(id => {
    //    IdsArray.push(id.BARITEMID);
    //    return document.getElementById(id.BARITEMID).toDataURL();
    //});

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={{ display: "flex", flexDirection: "column", "flexWrap": "wrap", 'width': '100%' }}>
                    <div style={{ display: "flex", flexDirection: "row", "flexWrap": "wrap", 'width': '50%', 'outline': '2px dashed gray' }}>
                        <Text style={{ width: '100%' }}> Door type: </Text>
                        <Text style={{ width: '100%' }}> </Text>
                        <Text style={{ width: '100%' }}>{doortype} </Text>
                        <Text style={{ width: '100%' }}> </Text>
                        <Text style={{ width: '100%' }}> </Text>
                        <Text style={{ width: '100%' }}>Door Swing:</Text>
                        <Text style={{ width: '100%' }}> </Text>
                        <Text style={{ width: '100%' }}>{DoorSwingType}</Text>
                        <Text style={{ width: '100%' }}> </Text>
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[0] != undefined ?
                            <Text style={{ width: '100%' }}>User Needs:</Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[0] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[0].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[0].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[1] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[1].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[1].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[2] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[2].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[2].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[3] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[3].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[3].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[4] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[4].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[4].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[5] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[5].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[5].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[6] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[6].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[6].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[7] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[7].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[7].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[8] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[8].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[8].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[9] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[9].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[9].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[10] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[10].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[10].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[11] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[11].label}</Text>
                                <Text style={{ width: '100%' }}>:</Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[11].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>
                        {WillYouNeedArray[12] != undefined ?
                            <Text><Text style={{ width: '100%' }}>{WillYouNeedArray[12].label}</Text>
                                <Text style={{ width: '100%' }}>: </Text>
                                <Text style={{ width: '100%' }}>{WillYouNeedArray[12].value}</Text></Text> : null}
                        <Text style={{ width: '100%' }}> </Text>

                    </div>

                </View>
            </Page>
        </Document>
    );
};

export default EnersysPDFComponent;